import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { EndPointApi } from '@helpers/endpointapi';
import { SocketService } from '@service/socket.service';
import { AlarmHistoryData } from 'ops/common/models/alarm-history-data';

import { lastValueFrom } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AlarmHistoryService {
    private domain: string;

    public alarmHistoryArray: AlarmHistoryData[] = [];
    public alarmHistoryDatas: AlarmHistoryData[] = [];

    public alarmHistoryData: AlarmHistoryData[] = [];

    constructor(
        private http: HttpClient,
        private socketService: SocketService,
    ) {
        this.domain = EndPointApi.iApiDomain();
    }

    getAlarmHistoryDataAPI(): Promise<any> {
        return lastValueFrom(this.http.get(`${this.domain}/api/histories/alarms`));
    }
}
